module.exports = __webpack_public_path__ + "static/media/happy-customer-bg.de86fa97.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/happy-customer-bg.png
// module id = 290
// module chunks = 0